import PropTypes from 'prop-types';
import moment from 'moment-timezone';

var propTypes = {
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    selectedRange: PropTypes.string,
    onDatesChange: PropTypes.func,
    calendarLocale: PropTypes.string,
    rangeLabels: PropTypes.object,
    dateLabels: PropTypes.object,
    sidebarHeader: PropTypes.string,
    applyFiltersText: PropTypes.string,
    dateFormat: PropTypes.string,
    inputDateFormats: PropTypes.arrayOf(PropTypes.string),
    startDateInputRef: PropTypes.object,
    endDateInputRef: PropTypes.object,
    calendarProps: PropTypes.object,
    sidebarZIndex: PropTypes.number,
    invalidInputErrorMessage: PropTypes.string,
    sidebarProps: PropTypes.object,
    isDayBlocked: PropTypes.func,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    customDateRanges: PropTypes.array,
    customSelectedRange: PropTypes.object,
    isCustomRangeShowed: PropTypes.bool,
    timeZone: PropTypes.string,
};
var rangeLabels = {
    today: 'Today',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    custom: 'Custom',
};
var dateLabels = {
    startDate: 'Start Date',
    endDate: 'End Date',
};
var defaultProps = {
    selectedRange: 'custom',
    calendarLocale: 'en-US',
    rangeLabels: rangeLabels,
    dateLabels: dateLabels,
    sidebarHeader: 'View Date',
    applyFiltersText: 'Apply Filters',
    dateFormat: 'MM/DD/YYYY',
    inputDateFormats: ['MM/DD/YYYY'],
    startDate: null,
    endDate: null,
    calendarProps: {},
    invalidInputErrorMessage: 'Invalid Input',
    isCustomRangeShowed: true,
    customSelectedRange: {
        name: 'custom',
        startDate: moment().startOf('day'),
        endDate: moment().endOf('day'),
    },
    timeZone: moment.tz.guess(),
};

export { defaultProps, propTypes };
